// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1F1NM","signatureButtonsRight":"ModalSign_signatureButtonsRight__1aB-l"};